export default __webpack_public_path__ + "static/media/icon-valor.e2e58d72.svg";